export { List } from './list.component';
